import type { ScrollAreaDesignTokens } from '@primeuix/themes/types/scrollarea';

export default {
    root: {
        background: '{content.background}',
        borderColor: '{content.border.color}',
        borderRadius: '{content.border.radius}',
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: '{focus.ring.shadow}',
        },
    },
    viewport: {
        padding: '1rem',
    },
    scrollbar: {
        background: 'transparent',
        margin: '0.25rem',
        size: '0.25rem',
        transitionDuration: '{transition.duration}',
    },
    handle: {
        background: '{content.border.color}',
    },
    mask: {
        fadeSize: '40px',
    },
} satisfies ScrollAreaDesignTokens;
